import { i as inject } from "../services/current-app-832a37a5.mjs";
import { c as createGlobalConfig, p as provideForCurrentApp, G as GLOBAL_CONFIG } from "../services/global-config/global-config-415d2d5b.mjs";
function useGlobalConfig() {
  let injected = inject(GLOBAL_CONFIG);
  if (!injected) {
    injected = createGlobalConfig();
    provideForCurrentApp(injected);
  }
  return injected;
}
export {
  useGlobalConfig as u
};
//# sourceMappingURL=useGlobalConfig-76a35e40.mjs.map
